var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.multi_factor_key
    ? _c("div", { staticClass: "row" }, [
        _c(
          "div",
          {
            staticClass:
              "col-md-4 col-sm-4 col-xs-8 xs-mr-tp-10 xs-mr-bt-10 display-flex-mobile",
            class: _vm.xshide ? "hidden-xs" : "",
          },
          [
            _c("div", { staticClass: "collapse-drop-label" }, [
              _vm._v("Role:"),
            ]),
            _c("div", [
              _vm.getRoleName(_vm.member.role_id)
                ? _c("span", { staticClass: "custom-dropdown" }, [
                    _vm._v(
                      " " + _vm._s(_vm.getRoleName(_vm.member.role_id)) + " "
                    ),
                  ])
                : _c("span", [
                    _vm.member.role_id === 1
                      ? _c("div", [_vm._v("Account Owner")])
                      : _vm.member.role_id === 5
                      ? _c("div", [_vm._v("Emergo alert admin")])
                      : _vm.member.role_id === 7
                      ? _c("div", [_vm._v("Emergo alert writer")])
                      : _vm._e(),
                  ]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass:
              "col-lg-4 col-md-4 col-sm-4 col-xs-8 xs-mr-tp-10 xs-mr-bt-10 display-flex-mobile",
            class: _vm.xshide ? "hidden-xs" : "",
          },
          [
            _c("div", { staticClass: "collapse-drop-label" }, [
              _vm._v("Distributor:"),
            ]),
            _c("div", { staticClass: "custom-dropdown" }, [
              _vm._v(
                _vm._s(
                  _vm.getDistributorName(_vm.member.assigned_distributor_id)
                )
              ),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass:
              "col-lg-4 col-md-4 col-sm-4 col-xs-8 xs-mr-tp-10 xs-mr-bt-10 display-flex-mobile",
            class: _vm.xshide ? "hidden-xs" : "",
          },
          [
            _c("div", { staticClass: "collapse-drop-label" }, [
              _vm._v("IP Address:"),
            ]),
            _c("div", { staticClass: "custom-dropdown" }, [
              _vm._v(_vm._s(_vm.member.ip_address)),
            ]),
          ]
        ),
      ])
    : _c("div", { staticClass: "row" }, [
        _c(
          "div",
          {
            staticClass:
              "col-md-6 col-sm-6 col-xs-8 xs-mr-tp-10 xs-mr-bt-10 display-flex-mobile",
            class: _vm.xshide ? "hidden-xs" : "",
          },
          [
            _c("div", { staticClass: "collapse-drop-label" }, [
              _vm._v("Role:"),
            ]),
            _c("div", [
              _vm.getRoleName(_vm.member.role_id)
                ? _c("span", { staticClass: "custom-dropdown" }, [
                    _vm._v(
                      " " + _vm._s(_vm.getRoleName(_vm.member.role_id)) + " "
                    ),
                  ])
                : _c("span", [
                    _vm.member.role_id === 1
                      ? _c("div", [_vm._v("Account Owner")])
                      : _vm.member.role_id === 5
                      ? _c("div", [_vm._v("Emergo alert admin")])
                      : _vm.member.role_id === 7
                      ? _c("div", [_vm._v("Emergo alert writer")])
                      : _vm._e(),
                  ]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass:
              "col-md-6 col-sm-6 col-xs-8 xs-mr-tp-10 xs-mr-bt-10 display-flex-mobile",
            class: _vm.xshide ? "hidden-xs" : "",
          },
          [
            _c("div", { staticClass: "collapse-drop-label" }, [
              _vm._v("Distributor:"),
            ]),
            _c("div", { staticClass: "custom-dropdown" }, [
              _vm._v(
                _vm._s(
                  _vm.getDistributorName(_vm.member.assigned_distributor_id)
                )
              ),
            ]),
          ]
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }